import { faCheckCircle, faHeadset, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { Fragment } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import { RegistrationV2State } from "features/registration-v2/registrationV2Slice";
import LoadingSpinner from "components/LoadingSpinner";
import { URL_SUPPORT_GENERAL } from "screens/SupportScreen";


export const ContactSupportLink = () => (
    <a
        href={URL_SUPPORT_GENERAL}
        target="_blank"
        rel="noreferrer"
        className="fake-link contact-support-link"
        data-testid="contact-support-link"
    >
        <FontAwesomeIcon icon={faHeadset} />
        <span>
            <FormattedMessage id="CONTACT_SUPPORT" />
        </span>
    </a>
)


export const TeamleaderSubscriptionStatus = (props: Props) => {
    const { processingSigning, teamleaderSubscriptionSuccessful, teamleaderSubscriptionError } = props.registration;

    if (processingSigning) {
        return <LoadingSpinner message={<FormattedMessage id="REGISTRATION_VERIFYING_TRANSACTION" />} />
    }

    if (teamleaderSubscriptionError) {
        console.log('Teamleader errors: ', teamleaderSubscriptionError);
        Sentry.setContext('teamleader-subscription-error', teamleaderSubscriptionError);
        Sentry.captureMessage('Error processing Teamleader subscription', teamleaderSubscriptionError);

        

        return (
            <Fragment>
                <div className="flex">
                    <FontAwesomeIcon icon={faTimesCircle} size="2xl" color="#EF6F6C" />
                    <h3 className="bold-title red" style={{ marginLeft: '1em' }}>
                        <FormattedMessage id="TEAMLEADER_SUBSCRIPTION_ERROR_TITLE" />
                    </h3>
                </div>
                <p className="red" style={{ marginTop: '0.5em' }}>
                    <FormattedMessage id="TEAMLEADER_SUBSCRIPTION_ERROR_DETAIL" />
                </p>
                <div className="center">
                    <ContactSupportLink />
                </div>
            </Fragment>
        )
    }

    if (teamleaderSubscriptionSuccessful) {
        return (
            <Fragment>
                <div className="flex">
                    <FontAwesomeIcon icon={faCheckCircle} size="2xl" color="#35D38C" />
                    <h3 className="bold-title" style={{ marginLeft: '1em', color: '#35D38C' }}>
                        <FormattedMessage id="TEAMLEADER_SUBSCRIPTION_OK_TITLE" />
                    </h3>
                </div>
                <p style={{ marginTop: '0.5em', color: '#35D38C' }}>
                    <FormattedMessage id="TEAMLEADER_SUBSCRIPTION_OK_DETAIL" />
                </p>
            </Fragment>
        )
    }
}

type Props = { registration: RegistrationV2State };